import { FundingRequestList } from "modules/finances";
import { Title } from "modules/layout";
import Link from "next/link";
import { useRouter } from "next/router";
import { CompanyFinancesLayout } from "pages/[company]/finances/_layout";
import pages from "pages/_router";
import React, { useState } from "react";
import { api, FundingRequestSearchQueryStatus } from "shared/api";
import { Button, Empty, InputDebounced, Select, Switch } from "shared/ui";
import styles from "./index.page.module.scss";

const FinancesFundingRequestsPage = () => {
  const companySlug = useRouter().query.company as string;
  const me = api.companyEmployee.useCompanyEmployeeMe(companySlug);

  const [status, setStatus] = useState<FundingRequestSearchQueryStatus>();
  const [my, setMy] = useState<boolean>();
  const [fundId, setFundId] = useState<string>();
  const [search, setSearch] = useState<string>();

  const fundingRequestList = api.fundingRequest.useFundingRequestList({
    companyIdOrSlug: companySlug,
    status,
    my,
    fundId,
    search,
  });

  const fundGroupList = api.fundGroup.useFundGroupList(companySlug);
  const fundList = api.fund.useFundList(companySlug);

  return (
    <CompanyFinancesLayout>
      <Title
        actions={
          <Link href={pages.company(companySlug).finances.fundingRequests.new.href} legacyBehavior>
            <Button type="secondary" size="small">
              Создать заявку
            </Button>
          </Link>
        }
      >
        Заявки на расходы
      </Title>

      <div className={styles.filters}>
        <div className={styles.line}>
          <Switch
            items={[
              { name: "Все", value: undefined },
              { name: "Ждут допуска к ФП", value: FundingRequestSearchQueryStatus.NEW },
              { name: "Открытые", value: FundingRequestSearchQueryStatus.OPENED },
              { name: "К выплате", value: FundingRequestSearchQueryStatus.FOR_PAYMENT },
              { name: "Закрытые", value: FundingRequestSearchQueryStatus.CLOSED },
            ]}
            active={status}
            onChange={setStatus}
          />

          <Switch
            items={[
              { name: "Все", value: undefined },
              { name: "Мои", value: true },
            ]}
            active={my}
            onChange={setMy}
          />

          <Select
            className={styles.funds}
            value={fundId}
            onChange={setFundId}
            placeholder="Все фонды"
            allowEmpty
            options={fundGroupList.data?.map((group) => ({
              key: group.id,
              label: group.name,
              options: fundList.data
                ?.filter((it) => it.fundGroupId === group.id)
                .map((it) => ({
                  value: it.id,
                  label: it.name,
                })),
            }))}
          />
        </div>

        <div className={styles.line}>
          <InputDebounced placeholder="Поиск" className={styles.search} value={search} onChange={setSearch} />
        </div>
      </div>

      <FundingRequestList
        companySlug={companySlug}
        {...fundingRequestList}
        showTotal
        empty={
          <Empty
            title="Заявок на расходы нет"
            description="Тут будут отображаться заявки на расход"
            actions={
              <Link href={pages.company(companySlug).finances.fundingRequests.new.href} legacyBehavior>
                <Button type="secondary" size="small">
                  Создать заявку
                </Button>
              </Link>
            }
          />
        }
      />
    </CompanyFinancesLayout>
  );
};

export default FinancesFundingRequestsPage;
